import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tray: [],
};

export const traySlice = createSlice({
  name: 'tray',
  initialState,
  reducers: {
    setTray: (state, action) => {
      state.tray = action.payload; // Directly modify the tray property
    },
    clearTrayState: (state) => {
      state.tray = []; // Reset tray to an empty array
    },
  },
});

export const { setTray, clearTrayState } = traySlice.actions;

export const trayData = (state) => state.tray;

export default traySlice.reducer;
